export enum Mode {
  Selection = "selection",
  Bubble = "bubble",
}
